import { FC } from 'react';

import { Typography } from '@mui/material';

import { Flex } from 'src/components/Flex';
import { BOX_SHADOW, DEFAULT_BORDER } from 'src/constants';

const DisplayCard: FC<{ label: string; value: string }> = ({ label, value }) => {
    return (
        <Flex
            sx={{
                ...DEFAULT_BORDER,
                boxShadow: BOX_SHADOW,
                flex: 1,
                flexDirection: 'column',
                overflow: 'hidden',
            }}
        >
            <Flex padding="8px 14px" bgcolor="#F39E4E" flex={1} justifyContent="center">
                <Typography color="white" fontSize="18px" fontWeight="500" lineHeight="26px">
                    {label}
                </Typography>
            </Flex>
            <Flex padding="16px 24px" justifyContent="center">
                <Typography
                    color="#575757"
                    fontSize="24px"
                    fontWeight="400"
                    lineHeight="36px"
                    textAlign="center"
                >
                    {value}
                </Typography>
            </Flex>
        </Flex>
    );
};

export default DisplayCard;
